type TConst =
    | "auth-token-name-v2"
    | "api-url-v2"
    | "menu-width"
    | "app-version"
    | "tiny-mce"
    | "assets-images-path"
    | "env-type"
    | "site-name"
    | "tg-bot-name"
    | "metabase-url"
    | "firebase-server-key"
    | "firebase-config"
    | "nda-version"
    | "maxbot-link";

const getConst = (name: TConst): any => {
    switch (name) {
        case "auth-token-name-v2":
            return import.meta.env.VITE_COOKIE_NAME + "v2";
        case "menu-width":
            return 280;
        case "maxbot-link":
            return `https://max.ru/${import.meta.env.VITE_MAXBOT_NAME}`;
        case "api-url-v2":
            return import.meta.env.VITE_API_V2;
        case "app-version":
            return import.meta.env.VITE_VERSION;
        case "tiny-mce":
            if (import.meta.env.VITE_ENVIRONMENT === "production") {
                const day = new Date().getDay();
                switch (day) {
                    case 1:
                        return import.meta.env.VITE_TINYMCE1;
                    case 2:
                        return import.meta.env.VITE_TINYMCE2;
                    case 3:
                        return import.meta.env.VITE_TINYMCE3;
                    case 4:
                        return import.meta.env.VITE_TINYMCE4;
                    case 5:
                        return import.meta.env.VITE_TINYMCE5;
                    case 6:
                        return import.meta.env.VITE_TINYMCE6;
                }
            }
            return import.meta.env.VITE_TINYMCE;
        case "env-type":
            return import.meta.env.VITE_ENVIRONMENT;
        case "site-name":
            return import.meta.env.VITE_WEBSITE_NAME;
        case "tg-bot-name":
            return import.meta.env.VITE_TG_BOT;
        case "assets-images-path":
            return import.meta.env.BASE_URL + "assets/images/";
        case "metabase-url":
            return import.meta.env.VITE_METABASE_URL;
        case "firebase-server-key":
            return import.meta.env.VITE_FIREBASE_SERVER_KEY;
        case "firebase-config":
            return {
                apiKey: import.meta.env.VITE_FIREBASE_CONFIG_API_KEY,
                authDomain: import.meta.env.VITE_FIREBASE_CONFIG_AUTH_DOMAIN,
                projectId: import.meta.env.VITE_FIREBASE_CONFIG_PROJECT_ID,
                storageBucket: import.meta.env.VITE_FIREBASE_CONFIG_STORAGE_BUCKET,
                messagingSenderId: import.meta.env.VITE_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
                appId: import.meta.env.VITE_FIREBASE_CONFIG_APP_ID,
            };
        case "nda-version":
            return Number(import.meta.env.VITE_NDA_VERSION || 1);
    }
};
export default getConst;
